exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-3a5f11a3] .modal-body{margin-bottom:127px!important}", ""]);

// exports
